import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccionTarea, NuevaTarea } from '../models/Tarea';
import { environment } from '../../environments/environment';
import { ListadoDocumentoPaginado, TramitePortal } from '../models/Document';
import { Anexo } from '../models/Anexo';

@Injectable({
  providedIn: 'root'
})
export class TareaService {

  private REASIGNAR_DOCUMENTO_URL = environment.apiUrl + "ta/ra"
  private DIRECCIONAR_DOCUMENTO_URL = environment.apiUrl + "ta/di"
  private RESPONDER_DOCUMENTO_URL = environment.apiUrl + "ta/r/"
  private ARCHIVAR_DOCUMENTO_URL = environment.apiUrl + "ta/a"
  private RESTAURAR_DOCUMENTO_URL = environment.apiUrl + "ta/a/r"
  private POST_ANEXOS_TAREA_URL = environment.apiUrl + "an/"
  private DELETE_ANEXO_TAREA_URL = environment.apiUrl + "an/e/"
  private GET_TAREAS_DOCUMENTO_URL = environment.apiUrl + "ta/s/"
  private REDACCION_URL = environment.apiUrl + "an/rd"

  private POST_REPORTA_AVANCE_TAREA = environment.apiUrl + "ta/at"
  private POST_COMENTAR_TAREA_URL = environment.apiUrl + "ta/co"
  private POST_CANCELAR_TAREA_URL = environment.apiUrl + "ta/ct"
  private POST_REABRIR_TAREA_URL = environment.apiUrl + "ta/rat"

  private POST_CERRAR_NUEVAS_TAREAS_DOCUMENTO_ELABORACION_URL = environment.apiUrl + "ta/ce/"
  private POST_FIRMA_CONJUNTA_NUEVAS_TAREAS_URL = environment.apiUrl + "ta/tfc/"

  constructor(
    private http: HttpClient
  ) { }

  ReasignarDocumento(accionTareas: AccionTarea[]): Observable<string> {
    return this.http.post(this.REASIGNAR_DOCUMENTO_URL, accionTareas, {
      responseType: 'text',
    });
  }

  DireccionarDocumento(accionTareas: AccionTarea[]): Observable<string> {
    return this.http.post(this.DIRECCIONAR_DOCUMENTO_URL, accionTareas, {
      responseType: 'text',
    });
  }

  ResponderDocumento(tramite: TramitePortal, idTarea: number): Observable<TramitePortal> {
    return this.http.post<TramitePortal>(this.RESPONDER_DOCUMENTO_URL + idTarea, tramite)
  }

  ArchivarDocumento(accionTareas: AccionTarea[]): Observable<string> {
    return this.http.post(this.ARCHIVAR_DOCUMENTO_URL, accionTareas, {
      responseType: 'text',
    });
  }

  RestaurarDocumento(accionTareas: AccionTarea[]): Observable<string> {
    return this.http.post(this.RESTAURAR_DOCUMENTO_URL, accionTareas, {
      responseType: 'text',
    });
  }

  nuevaTarea(accionTareas: AccionTarea[]): Observable<string> {
    return this.http.post(environment.apiUrl + "ta/nt", accionTareas, {
      responseType: 'text',
    });
  }

  getTareasByTareaID(tareaID: number, todos: number = 0): Observable<NuevaTarea[]> {
    return this.http.get<NuevaTarea[]>(this.GET_TAREAS_DOCUMENTO_URL + tareaID + "?t=" + todos)
  }

  postAnexosTarea(anexo: Anexo, idTarea: number): Observable<Anexo[]> {
    const formData: FormData = new FormData();

    anexo.file!.forEach((file) => {
      formData.append('file', file, file.name);
    });

    if (anexo.desc) {
      formData.append('desc', anexo.desc);
    }

    return this.http.post<Anexo[]>(this.POST_ANEXOS_TAREA_URL + idTarea, formData);
  }

  listado(
    tipoBandeja: string,
    fechaInicio: string,
    fechaFin: string,
    busqueda: string | null,
    tipoDocumento: number | null,
    pagina: number,
    numero: string | null,
    todos: number = 0
  ): Observable<ListadoDocumentoPaginado> {
    let params = new HttpParams();

    params = params.set('fi', fechaInicio);
    params = params.set('ff', fechaFin);
    if (busqueda) {
      params = params.set('b', busqueda);
    }
    if (tipoDocumento !== null && tipoDocumento !== undefined && tipoDocumento > 0) {
      params = params.set('td', tipoDocumento);
    }
    params = params.set('p', pagina);
    params = params.set('t', todos);
    if (numero) {
      params = params.set('nf', numero);
    }


    return this.http.get<ListadoDocumentoPaginado>(
      environment.apiUrl + "ta/l/" + tipoBandeja,
      { params }
    );
  }

  deleteAnexoTarea(idAnexo: number): Observable<string> {
    return this.http.delete(this.DELETE_ANEXO_TAREA_URL + idAnexo, {
      responseType: 'text',
    });
  }

  reportarAvanceTarea(accionTarea: AccionTarea[]): Observable<string> {
    return this.http.post(this.POST_REPORTA_AVANCE_TAREA, accionTarea, {
      responseType: 'text'
    })
  }

  comentarTarea(accionTarea: AccionTarea[]): Observable<string> {
    return this.http.post(this.POST_COMENTAR_TAREA_URL, accionTarea, {
      responseType: 'text'
    })
  }

  cancelarTarea(accionTarea: AccionTarea[]): Observable<string> {
    return this.http.post(this.POST_CANCELAR_TAREA_URL, accionTarea, {
      responseType: 'text'
    })
  }

  reabrirTarea(accionTarea: AccionTarea[]): Observable<string> {
    return this.http.post(this.POST_REABRIR_TAREA_URL, accionTarea, {
      responseType: 'text'
    })
  }

  recuperarReasignado(accionTarea: AccionTarea[]): Observable<string> {
    return this.http.post(environment.apiUrl + "ta/rc", accionTarea, {
      responseType: 'text'
    })
  }

  finalizarTarea(accionTarea: AccionTarea[]): Observable<string> {
    return this.reportarAvanceTarea(accionTarea)
  }

  cerrarNuevasTareasDocumentoEnElaboracion(tareaID: string): Observable<string> {
    return this.http.post(this.POST_CERRAR_NUEVAS_TAREAS_DOCUMENTO_ELABORACION_URL + tareaID, null, {
      responseType: 'text'
    })
  }

  firmaConjuntaCrearNuevasTareas(tareaID: string, idAnexo: string = ""): Observable<string> {
    var qParams = ""
    if (idAnexo != "") {
      qParams = "?idAnexo=" + idAnexo
    }
    return this.http.post(this.POST_FIRMA_CONJUNTA_NUEVAS_TAREAS_URL + tareaID + qParams, null, {
      responseType: 'text'
    })
  }

  saveRedaccion(tarea: TramitePortal): Observable<any> {
    return this.http.post(this.REDACCION_URL, tarea, {      
    })
  }

  getTareasHojaGuia(impresa: number = 0, fechaInicio: String, fechaFin: String, bandeja: number = 1): Observable<any> {
    return this.http.get(environment.apiUrl + "doc/hg/" + impresa + "?fi=" + fechaInicio + "&ff=" + fechaFin + "&b=" + bandeja)
  }

  reasignarDocumentosMasivo(data: any) :Observable<any> {
    return this.http.post<any>(environment.apiUrl + "a/rm", data)
  }

  getHojaGuia(tareas: any, bandeja: Number = 1): Observable<any> {
    return this.http.post(environment.apiUrl + "doc/hg?b=" + bandeja, tareas)
  }

  updateEstadoTareasHojaGuia(impresa: number = 0, ids: String): Observable<string> {
    return this.http.patch(environment.apiUrl + "doc/hg/" + impresa + "?ids=" + ids, {}, {
      responseType: 'text'
    })
  }

  recuperarTarea(data: AccionTarea): Observable<String> {
    return this.http.post(environment.apiUrl + "ta/rec/"+data.id, data, {
      responseType: 'text'
    })
  }

  alcanceTarea(data: AccionTarea): Observable<String> {
    return this.http.post(environment.apiUrl + "ta/al/"+data.id, data, {
      responseType: 'text'
    })
  }
}
